<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="copmaterials">
      <div slot="toolbar">
        <el-button v-if="editAuth" type="primary" @click="$refs.editPage.open()">新建</el-button>
        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="程序版本">
            <el-input v-model.trim="filter.materialNo" clearable/>
          </vm-search>
          <vm-search label="程序类型">
            <el-input v-model.trim="filter.param1" clearable/>
          </vm-search>
          <vm-search label="轿厢板">
            <el-input v-model.trim="filter.param2" clearable/>
          </vm-search>
          <vm-search label="电梯云">
            <el-input v-model.trim="filter.param3" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="materialNo" align="center" label="程序版本"/>
      <el-table-column prop="param1" align="center" label="程序类型"/>
      <el-table-column prop="param2" align="center" label="轿厢板"/>
      <el-table-column prop="param3" align="center" width="80" label="电梯云"/>
      <el-table-column prop="note" align="center" label="备注"/>
      <el-table-column
          label="操作"
          align="center" width="180"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" v-if="editAuth" @click="edit(scope.row,0)">编辑</el-button>
          <el-button type="danger" v-if="editAuth" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <cop-material-edit ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import CopMaterialEdit from "@/views/information/MaterialStandardMapping/CopMaterialEdit.vue";

  export default {
    name: "CopMaterialList",
    components: {CopMaterialEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        show: "",
        importLoading: false,
        exportLoading: false,
        editAuth: this.$auth(498),
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        disabled: false,
        filter: {
          materialNo: "",
          param1: "",
          param2: "",
          param3: "",
          materialType: "10",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      oneDelete(row) {
        let ids = [];
        ids.push(row.pkid);
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .post("basic", "copmaterials/delete", ids).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
      edit(row, isCopy) {
        this.$refs.editPage.open(row, isCopy);
      },
      //导出
      exportExcel() {
        this.exportLoading = true;
        this.$http
            .exportFile("basic", "copmaterials/export", this.filter)
            .then(res => {
              let blob = new Blob([res.data]);
              let fileName = decodeURI(res.headers.filename);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                let a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = fileName;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
              }
              this.exportLoading = false;
            })
            .catch(() => {
              this.exportLoading = false;
            });
      },

    },
  };
</script>
<style lang="scss" scoped>
</style>
